import { NavLink } from "react-router-dom";
import { Logo, User } from "../../assests/ExportImageIcon";
import "./sidebar.css";

const AdminSidebar = ({ collapsed }) => {
  return (
    <div className={`sidebar ${collapsed ? "collapsed" : ""}`}>
      <div className="logo">
        <img src={Logo} alt="Logo" className="logo-img" />
      </div>

      <ul className="menu">
        <li className="menu-item">
          <NavLink
            to="/dashboard"
            className={({ isActive }) => (isActive ? "menu-link active" : "menu-link")}
          >
            <img src={User} className="menu-icon-img" alt="" />
            {!collapsed && <span className="menu-text">User List</span>}
          </NavLink>
        </li>
      </ul>
    </div>
  );
};

export default AdminSidebar;
